import React, {Dispatch, SetStateAction, useState} from "react";
import {Button, Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import { Icon } from '@iconify/react';
import Divider from '@mui/material/Divider';
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import services from "../../services";
import CircularProgress from "@mui/material/CircularProgress";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {setInitialDevices} from '../../app/features/userSlice'



interface DeleteDevice {
    id : number,
    imei:string,
    handleClose : () =>void,
    name:string,
    setDevices : Dispatch<SetStateAction<any[]>>,
}


export const DeleteDevice = ({ id,imei,handleClose,name,setDevices } : DeleteDevice) =>{

    const allDevices = useSelector(((state:RootState) => state.user.devices))

    const dispatch = useDispatch()

    const [loader,setLoader] = useState<boolean>(false)

    const deleteDevice = () =>{
        setLoader(true)
        services
            .DeleteDevice({id : id,imei : imei})
            .then(res=>{
                let new_devices = allDevices.filter((d:any) =>d.id !== id)
                setDevices(new_devices)
                localStorage.setItem('devices',JSON.stringify(new_devices))
                dispatch(setInitialDevices(new_devices))
                setLoader(false)
                handleClose()
            })
            .catch(error=>{
                setLoader(false)
                handleClose()
            })
    }

    return (
            <Box sx={{flexGrow:1,width:600}}>
                <Grid container justifyContent={"space-between"}>
                    <Grid item>
                        <Typography
                            style={{
                                color:"#081735",
                                fontSize:"28px",
                                fontWeight:"700",
                            }}
                        >Are you sure?</Typography>
                    </Grid>
                    <Grid item>
                        <Icon
                            icon="akar-icons:cross"
                            style={{verticalAlign:"-10px",color:"#081735",fontSize:"20px",cursor:"pointer"}}
                            onClick={()=>handleClose()}
                        />
                    </Grid>
                </Grid>
                <Divider variant="middle" color={'#B8B8B8'}/>

                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={3}
                    mt={2}
                >
                    <Typography
                        fontWeight={800}
                    >
                        Do you really want to delete the device
                    </Typography>
                    <Typography
                    fontSize={40}
                    fontWeight={700}
                    >
                        “{name}”
                    </Typography>
                </Stack>

                <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={4}
                    mt={2}
                >
                    <Button
                        onClick={()=>{handleClose()}}
                        variant="contained"
                        sx={{
                            borderRadius:"16px",
                            textTransform:"none",
                            border:"1px solid #8F95B2",
                            background:'none',
                            color:"#8F95B2",
                            fontWeight:700,
                            padding:1,
                            boxShadow:"none",
                            fontSize : "16px",
                            width:'150px'
                        }}>No</Button>
                    <Button
                        onClick={()=>{deleteDevice()}}
                        variant="contained"
                        sx={{
                            borderRadius:"16px",
                            background:"#089BAB",
                            textTransform:"none",
                            color:"#FFFFFF",
                            fontWeight:700,
                            padding:1,
                            boxShadow:"none",
                            fontSize : "16px",
                            width:'150px'
                        }}>
                        Yes
                        <CircularProgress sx={{position:"relative",left:"30px",color:"#FFFFFF",display:loader?" ":"none"}} size={25} thickness={6}/>
                    </Button>
                </Stack>
            </Box>
    )
}